import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { SubscriptionManagerButton } from "@/routes/_private/-components/cart/subscription-manager-button";
import { CareplanCartSubscriptionStatus } from "./careplan-cart-subscription-status";

export const UpdatedSubscriptionCard = () => {
  const { subscription } = useCareplanContext();

  if (!subscription) {
    return null;
  }

  return (
    <CareplanCartSubscriptionStatus.Root
      className="flex flex-col items-start gap-3"
      subscription={subscription}
    >
      <div className="flex w-full justify-between">
        <CareplanCartSubscriptionStatus.Title level={4}>
          Your New Subscription
        </CareplanCartSubscriptionStatus.Title>
        <CareplanCartSubscriptionStatus.ShippingFrequency />
      </div>

      <SubscriptionManagerButton
        className="rounded-sm text-sm font-normal text-accent underline underline-offset-4 hover:text-accent-hover"
        size="tight"
        variant="focus"
      >
        Subscription Manager
      </SubscriptionManagerButton>

      <CareplanCartSubscriptionStatus.NextBillingDate />

      <CareplanCartSubscriptionStatus.Description>
        After you update your subscription, you can change your billing date in the subscription
        manager.
      </CareplanCartSubscriptionStatus.Description>
    </CareplanCartSubscriptionStatus.Root>
  );
};
